<template>
  <div class="dynamic">
    <div class="padd-left">
      <div v-for="(item, index) in log.create" :key="index + 'c'">发布任务</div>
      <div v-for="(item, index) in log.take" :key="index + 't'">领取任务</div>
      <div v-for="(item, index) in log.askCheck" :key="index + 'a'">申请验收</div>
      <div v-for="(item, index) in log.checked" :key="index + 'c'">验收</div>
      <div v-for="(item, index) in log.payment" :key="index + 'p'">发放奖金</div>
    </div>
    <Steps class="steps" direction="vertical" :active="num" active-color="#4464eb">
      <Step v-for="item in log.create" :key="item.create_time" class="step">
        <div>{{item.username}} 发布任务</div>
        <p>{{item.create_time}}</p>
      </Step>
      <Step v-for="item in log.take" :key="item.create_time" class="step">
        <div>{{item.username}} 领取任务</div>
        <p>{{item.create_time}}</p>
      </Step>
      <Step v-for="item in log.askCheck" :key="item.create_time" class="step">
        <div>{{item.username}} 申请验收</div>
        <p>{{item.create_time}}</p>
      </Step>
      <Step v-for="item in log.checked" :key="item.create_time" class="step">
        <div>{{item.username}} 验收</div>
        <p>{{item.create_time}}</p>
      </Step>
      <Step v-for="item in log.payment" :key="item.create_time" class="step">
        <div>{{item.username}} 发放奖金</div>
        <p>{{item.create_time}}</p>
      </Step>
    </Steps>
  </div>
</template>

<script>
import { Step, Steps } from 'vant';
import { getDayType } from '@/api/api/task'
export default {
  data() {
    return {
      log: {},
      num: 0
    }
  },
  components: {
    Step,
    Steps
  },
  created() {
    var task_id = this.$route.query.task_id
    getDayType(task_id).then(res => {
      this.log = res.data.data
      this.num = ((res.data.data.create ? res.data.data.create.length : 0) + (res.data.data.take ? res.data.data.take.length : 0) + (res.data.data.askCheck ? res.data.data.askCheck.length : 0) + (res.data.data.checked ? res.data.data.checked.length : 0) + (res.data.data.payment ? res.data.data.payment.length : 0) - 1)
    })
  }
}
</script>

<style lang="scss">
.dynamic {
  background: white;
  font-size: 14px;
  display: flex;
  .padd-left {
    flex: 0.3;
    text-align: right;
    div {
      height: 90px;
      line-height: 90px;
    }
  }
  .steps {
    flex: 0.7;
      padding-top: 30px;
    .step {
      height: 90px;
    }
  }
}
</style>